// Deterministic pseudo-random helpers used to draw mock sparklines/charts.
// (Real series will come from the ORCA API; these keep mock visuals stable.)
export function rng(seed: number) {
  let s = seed * 9301 + 49297;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

export function walk(seed: number, n: number, trend: number) {
  const r = rng(seed);
  const raw: number[] = [];
  let v = 0;
  for (let i = 0; i < n; i++) {
    v += (r() - 0.5) * 2 + trend * 0.35;
    raw.push(v);
  }
  const lo = Math.min(...raw);
  const hi = Math.max(...raw);
  return raw.map((x) => (x - lo) / (hi - lo || 1));
}

export type Pt = [number, number];
export function smooth(pts: Pt[]) {
  return pts
    .map((p, i) => {
      if (!i) return `M${p[0].toFixed(1)},${p[1].toFixed(1)}`;
      const [px, py] = pts[i - 1];
      const c = (px + p[0]) / 2;
      return `C${c.toFixed(1)},${py.toFixed(1)} ${c.toFixed(1)},${p[1].toFixed(1)} ${p[0].toFixed(1)},${p[1].toFixed(1)}`;
    })
    .join(' ');
}

export const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
